<template>
    <q-page padding>
        <q-tabs color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab default slot="title" name="feed" :label="$t(title_feed)" icon="fal fa-broadcast-tower" />

            <q-tab-pane name="feed">
                <div class="row">
                    <div class="col-xs-12 col-sm-12">
                        <activities :page_feed='true'/>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import Activities from 'components/feed/Activities.vue'
import { mapGetters } from 'vuex'
export default {
    i18nOptions: { namespaces: [ "custom", 'custom' ,'common', 'feed'] },

    components: {
        'activities': Activities
	},
	data(){
		return{}
	},
	computed: {
        ...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected'
		}),

		title_feed() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_feed == "" ? 'feed' : obj.title_feed
				}
			}
		},
	},

}
</script>

<style>

</style>
